export enum ReminderType{
    WORKITEM = "WORKITEM",
    GENERIC = "GENERIC"

}